import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from '../../templates/services/base-service.template';
import { Core2Config } from '../../utils/core2-config';
import { ApiVisa } from '../../models/base/apivisa.model';
import { ApiResponseModel } from '../../models/base/api-response.model';
import { AppLoginContainerModel } from '../../models/app/app-login-container.model';
import { RegisterContainerModel } from '../../models/auth/register-container.model';
import { AppleProfile, FacebookProfile, GoogleProfile } from '../../models/auth/social-auth-container.model';
import { getHttpHeader } from '../../utils/http-header.factory';

@Injectable({
  providedIn: 'root'
})
export class TenantAuthService implements BaseService {

  public readonly apiUrl: string = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'ecom/identity';
    
  constructor(protected readonly http: HttpClient) {}

  public login(data: { email?: string, mobileNumber?: string, password: string }, code: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<any>{
    return this.http.post(`${ api_domain_url }${ this.apiUrl }/login?websiteCode=${ code }`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public register(data: RegisterContainerModel, flow: boolean, code: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<ApiResponseModel<AppLoginContainerModel>>{
    return this.http.post<ApiResponseModel<AppLoginContainerModel>>(`${ api_domain_url }${ this.apiUrl }/registration?tenantCode=${ tenantCode }&followExistingWorkflow=${ flow }&websiteCode=${ code }`, data, getHttpHeader(jwt_secret, tenantCode));
  }

  public socialLogin(type: 'google' | 'apple' | 'facebook', data: GoogleProfile | FacebookProfile | AppleProfile, code: string, { api_domain_url, jwt_secret, tenantCode }: ApiVisa): Observable<any>{
    return this.http.post<any>(`${ api_domain_url }${ Core2Config.TENANT_DOMAIN_URL_PREFIX }/identity/login/${ type }?websiteCode=${ code }`, data, getHttpHeader(jwt_secret, tenantCode));
  }
}
